import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import FavoriteIcon from "@material-ui/icons/Favorite";

function Copyright() {
  return (
    <Typography variant='body2' color='textSecondary'>
      {"Copyright © "}
      <Link
        color='inherit'
        href='https://cuttingedge-events.com/'
        target='_blank'
        rel='noreferrer'
      >
        cuttingedge-events.com
      </Link>
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function StickyFooter() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container maxWidth='sm'>
        <Typography variant='body1'>
          Curated with
          <FavoriteIcon style={{ color: "red" }} />
          by the{" "}
          <span>
            <a
              href='https://cuttingedge-events.com'
              target='_blank'
              rel='noreferrer'
            >
              CUTT/events
            </a>
          </span>{" "}
          people.
        </Typography>
        <Copyright />
      </Container>
    </footer>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: "auto",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
  },
}));
